/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Generic_RetryInputs */

const cs_error_generic_retry = /** @type {(inputs: Error_Generic_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Něco se pokazilo. Zkuste to znovu, nebo kontaktujte podporu.`)
};

const en_error_generic_retry = /** @type {(inputs: Error_Generic_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again or contact support.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again or contact support." |
*
* @param {Error_Generic_RetryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const error_generic_retry = /** @type {((inputs?: Error_Generic_RetryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Generic_RetryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_generic_retry(inputs)
	return cs_error_generic_retry(inputs)
});